import React from 'react';
import PriceHistoryChart from './PriceHistoryChart';
import Footer from './Footer'; 

const History = () => {
  return (
    <div className="history-page">
      <h1>Price History</h1>
      <p>U.S. All Grades All Formulations Retail Gasoline Prices (Dollars per Gallon)</p>
      <PriceHistoryChart csvFilePath="/data/US_all_grade_history_data.csv" />
      <Footer />
    </div>
  );
};

export default History;